// removed by extract-text-webpack-plugin
module.exports = {"resultHeading":"MultipleChoise__resultHeading___3L1Go","options":"MultipleChoise__options___1R48-","correct":"MultipleChoise__correct___9yZRn","wrong":"MultipleChoise__wrong___3oDOH","result":"MultipleChoise__result___tZWtP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/MultipleChoise.scss
// module id = 574
// module chunks = 1